// import { API } from '../../../../../../api';

const getDisplayTime = (start: number) => {
  const min = Math.floor(start / 60)
  const sec = Math.floor(start - min * 60)
  return (
    ((min + '').length === 2 ? min : '0' + min) + ':' + ((sec + '').length === 2 ? sec : '0' + sec)
  )
}

const toSeconds = (time: string) => {
  const [str, ms] = time.split(',')
  const [hr = '00', min = '00', sec = '00'] = str.split(':')
  return (
    parseInt(hr, 10) * 3600 + parseInt(min, 10) * 60 + parseInt(sec, 10) + parseInt(ms, 10) / 1000
  )
}

type TranscriptLine = {
  id: number
  index: number
  start: number
  end: number
  insertGap: boolean
  line: string
  displayTime: string
}

type TranscriptParagraph = {
  displayTime: string
  lines: TranscriptLine[]
}

export const createTranscript = (transcript: string): TranscriptParagraph[] => {
  let index = -1
  let previousTime = ''

  const lines: TranscriptLine[] = transcript.split('\n\n').map((line) => {
    const [lineId, times, ...rest] = line.split('\n')
    const [start, end] = times.split(' --> ')
    let fullLine = rest.join(' ').trim()

    const insertGap = start !== previousTime && /[A-Z\[]/.test(fullLine.substr(0, 1))
    previousTime = end

    if (fullLine.startsWith('- [')) {
      fullLine = fullLine.replace('- ', '')
    }

    index += 1

    const cleanStart = toSeconds(start)
    const cleanEnd = toSeconds(end)

    return {
      id: parseInt(lineId, 10),
      // start,
      // end,
      line: fullLine,
      insertGap,
      index,
      start: cleanStart,
      end: cleanEnd,
      displayTime: getDisplayTime(cleanStart),
    }
  })

  return lines.reduce((acc, line) => {
    if (line.insertGap) {
      return [...acc, { displayTime: getDisplayTime(line.start), lines: [line] }]
    }

    const last = acc[acc.length - 1]
    if (last) {
      last.lines.push(line)
    } else {
      return [...acc, { displayTime: getDisplayTime(line.start), lines: [line] }]
    }

    return acc
  }, [] as TranscriptParagraph[])
}
